import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StandingsDialogComponent } from '../components/standings.dialog.component';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'matches',
  templateUrl: '../sharedTemplates/matches.component.html',
})
export class MatchesComponent {
  @Input() _isLive = false;
  @Input() isFavories = false;
  @Input() __fixture = <any>[];
  @Input() _selectedOdds = [];
  @Input() oddType = 0;
  @Input() _sportName;
  @Output() addOdd = new EventEmitter();
  @Output() favChanged = new EventEmitter();
  @Input() oddTiles = [];

  _storySportsData = this._DataHelper.storySportsData;

  // 8 datas from prematch.
  // index 8 which is 9th item start with live match first item.
  oddTypes = this._DataHelper.oddTypes;

  constructor(public _DataHelper: DataHelper, public dialog: MatDialog, public _UiHelper: UiHelper) {}

  f_storySportsDataImg(e) {
    return this._storySportsData.find(x => {
      return x.SportName === e;
    });
  }

  sportName(e) {
    return Object.prototype.hasOwnProperty.call(this.oddTypes[this.oddType], e) ? e : 'all';
  }

  clickOddUP(_oddId) {
    this.addOdd.emit(_oddId);
  }

  openDialogStandings(e): void {
    //console.log("----__fixture---",e);
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      data: { tournamentId: e.BetradarTournamentId, sportId: e.SportId, type: 'statistic' },
    });
  }
  add2TournamentFavs(tour, cat) {
    const favitem = {
      tourid: tour.TournamentId,
      tourname: tour.TournamentName,
      catid: cat.CategoryId,
      catname: cat.CategoryName,
      count: tour.TournamentSportEventCount,
    };
    tour['checked'] = !tour['checked'];
    this._UiHelper.favTournamentChanged(favitem);
  }

  pairWithMatchID(index: number, event: any) {
    const matchId = event.MatchId && event.EventId;
    return matchId + event.SportNameOriginal;
  }
}
